import DateTimeOffset from "sap/ui/model/odata/type/DateTimeOffset";
import UI5Date from "sap/ui/core/date/UI5Date";

export default class TimeUtil {

  public static now(): Date {
    return new Date();
  }

  public static formatPattern(date: Date, pattern: string): string {
    const pad = (n: number, len = 2) => String(n).padStart(len, "0");
    return pattern
      .replace(/YYYY/g, String(date.getFullYear()))
      .replace(/YY/g, String(date.getFullYear()).slice(-2))
      .replace(/MM/g, pad(date.getMonth() + 1))
      .replace(/DD/g, pad(date.getDate()))
      .replace(/HH/g, pad(date.getHours()))
      .replace(/mm/g, pad(date.getMinutes()))
      .replace(/ss/g, pad(date.getSeconds()));
  }
  public static formatIntoV4Date(date: Date| string): Date | UI5Date | string {
      if(!date || date === ""){
          return null;
      }
      if (typeof date === "string") {
          date = new Date(date);
      }
      const oDateTimeOffset = new DateTimeOffset({}, { V4: true });
      return oDateTimeOffset.parseValue(date, "object");
  }


}
